import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import FinanceContext from '~/context/home/FinanceContext';
import { ListenerEvent, type ListenerEventType } from './constants';

type RefreshFinancingPayload = {};

function isRefreshFinancingMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, RefreshFinancingPayload> {
  return message.event === ListenerEvent.RefreshFinancing;
}

export default function useRefreshFinanceHandler(): MessageHandler<
  ListenerEventType,
  RefreshFinancingPayload
> {
  const { triggerFetchFinance } = useContext(FinanceContext);

  return useMemo(
    () =>
      new MessageHandler(isRefreshFinancingMessage, () => {
        triggerFetchFinance();
      }),
    [triggerFetchFinance]
  );
}
